import Image from "common/components/Image";

import Page from "client/common/components/layouts/Page";
import StreamlinedHeader from "client/common/components/header/StreamlinedHeader";
import Body from "client/common/components/layouts/Body";
import Alert from "client/common/components/content/Alert";
import { useSupportChat } from "client/support/hooks";

import welcomeWindow from "../../images/welcome-window.svg";

import styles from "../../styles/AuthPage.module.less";

type AuthPageProps = {
  children?: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  flash?: React.ReactNode;
};

const AuthPage = ({ children, title, description, flash }: AuthPageProps) => {
  const chat = useSupportChat();

  return (
    <Page Header={<StreamlinedHeader onHelp={() => chat.show()} />} Footer={null}>
      <Body className={styles.body}>
        <div className={styles.main}>
          <div className={styles.heading}>
            <Image className={styles.image} src={welcomeWindow} alt="Welcome window" />
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.description}>{description}</div>
          </div>
          {flash && <Alert variant="info">{flash}</Alert>}
          {children && <div>{children}</div>}
        </div>
      </Body>
    </Page>
  );
};

export default AuthPage;
